import { MutationTree } from 'vuex';
import { 
  SET_APPLICATION_LIST, 
  SET_CURRENT_APPLICATION, 
  SET_APPLICATION_STEP, 
  ADD_NEW_MESSAGE, 
  SET_IS_ADMIN_VARIABLE, 
  DELETE_APPLICATION_CARD, 
  ACCEPT_APPLICATION, 
  DECLINE_APPLICATION, 
  SET_APPLICATIONS_EXIST, 
  LOAD_MORE_APPLICATIONS, 
  SET_APPLICATION_ANSWERS,
  SET_TOTAL_OPEN,
  SET_TOTAL_CLOSED,
  SET_TOTAL_QUEUE
} from './mutation-types';
import State from './state';
import camelizer from '../../../../../../services/convertDataStrategies/classes/camelizer';
import { IApplicationCard } from '../../../models/interfaces/applicationTrackingSystem/iApplicationCard'
import { IApplication } from '../../../models/interfaces/applicationTrackingSystem/iApplication'
import { IChangeApplicationStatusOutput } from "../../../models/interfaces/applicationTrackingSystem/iChangeApplicationStatusOutput";
import { IApplicationStatus } from "../../../models/interfaces/applicationTrackingSystem/iApplicationStatus";
import { IMessage } from "../../../models/interfaces/applicationTrackingSystem/iMessage";
import { IAnswerToQuestion } from "../../../models/interfaces/nonprofitProfile/iAnswerToQuestion";
import { IAnswer } from "../../../models/interfaces/applicationTrackingSystem/iAnswer";
import { Application } from "../../../models/classes/applicationTrackingSystem/application";

const mutations: MutationTree<State> = {
  [SET_APPLICATION_LIST](state: State, applicationsCard: IApplicationCard[]): void {
    state.profile.applications = applicationsCard;
  },

  [LOAD_MORE_APPLICATIONS](state: State, applicationsCard: IApplicationCard[]): void {
    state.profile.applications = state.profile.applications.concat(applicationsCard);
  },

  [SET_APPLICATION_ANSWERS](state: State, answers: IAnswerToQuestion[]): void {
    let listOfAnswers: IAnswer[] = answers as IAnswer[];
    state.profile.currentApplication.answers = Object.values(listOfAnswers);
  },

	[SET_CURRENT_APPLICATION](state: State, application: IApplication): void {
    state.profile.currentApplication = new Application(application);
  },

	[SET_IS_ADMIN_VARIABLE](state: State, isAdmin: boolean): void {
		state.profile.isAdmin = !!isAdmin;
  },

  [SET_APPLICATIONS_EXIST](state: State, applicationsExist: boolean): void {
    state.profile.applicationsExist = applicationsExist;
  },

  [SET_TOTAL_OPEN](state: State, totalOpen: number): void {
    state.profile.totalOpen = totalOpen;
  },

  [SET_TOTAL_CLOSED](state: State, totalClosed: number): void {
      state.profile.totalClosed = totalClosed;
  },

  [SET_TOTAL_QUEUE](state: State, totalQueue: number): void {
      state.profile.totalQueue = totalQueue;
  },

  [SET_APPLICATION_STEP](state: State, data: IApplicationStatus): void {
    let arr: IApplicationCard[] = Object.values(state.profile.applications);
    let index = arr.findIndex(a => a.applicationKey === data.applicationKey);

    state.profile.applications[index].step = data.step;
    state.profile.applications[index].status = data.status;
    state.profile.applications[index].nodeProgress = data.step > 3 ? '4a' : `${data.step}`;
    state.profile.currentApplication.step = data.step;
    state.profile.currentApplication.status = data.status;
    state.profile.currentApplication.nodeProgress = data.step > 3 ? '4a' : `${data.step}`;
  },

  [DELETE_APPLICATION_CARD](state: State, data: string): void {
    let arr: IApplicationCard[] = Object.values(state.profile.applications);
    let index = arr.findIndex(a => a.applicationKey === data);
    state.profile.applications = arr.filter(function (a) {
      return a.applicationKey != data;
    });
  },

	[ADD_NEW_MESSAGE](state: State, message: IMessage): void {
    if (!state.profile.currentApplication.messages) {
      state.profile.currentApplication.messages = [];
    }

    if (message.message.trim() != "") {
      state.profile.currentApplication.messages.push(message);
    }
	}
};

export default mutations;


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/applicationTrackingSystem/mutations.ts